var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sendingBulkMessagesDisabledInProvision)?_c('v-alert',{attrs:{"color":"red lighten-4","elevation":"2","icon":"mdi-alert-octagon-outline","prominent":""}},[_vm._v(" "+_vm._s(_vm.sendingBulkMessagesDisabledInProvisionMessage)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }